import request from "./request.js";

export default {
  showWordChat: (data) => {
    return request({
      url: "api/admin/word/showWordChat",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  showBookList: (data) => {
    return request({
      url: "api/admin/word/showBookList",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  editWordChat: (data) => {
    return request({
      url: "api/admin/word/editWordChat",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  getWordChatDTO: (data) => {
    return request({
      url: "api/admin/word/getWordChatDTO",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  updateWordAudio: (data) => {
    return request({
      url: "api/admin/word/updateWordAudio",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  updateSentenceAudio: (data) => {
    return request({
      url: "api/admin/word/updateSentenceAudio",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  showWord: (data) => {
    return request({
      url: "api/admin/word/showWord",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  updateWord: (data) => {
    return request({
      url: "api/admin/word/updateWord",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  syncSimilarWordDefinition: (data) => {
    const token = localStorage.getItem("m-token");

    return request({
      url: "api/admin/word/syncSimilarWordDefinition",
      data: data,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { token } : {}),
      },
    }).then((res) => {
      return res.data;
    });
  },
};
